import apiService from '../apiService'

export const businessController = configService => {
  const service = apiService(configService)

  return {
    businessCategory: () => {
      return service.get({
        url: `cms/buyer/getBusinessCategory`,
      })
    },

    businessType: () => {
      return service.get({
        url: `cms/buyer/getBusinessType`,
      })
    },

    regisCapital: () => {
      return service.get({
        url: `cms/buyer/mysupplier/getRegisCapital`,
      })
    },

    yearList: () => {
      return service.get({
        url: `cms/buyer/getYearEstablishedList`,
      })
    },
  }
}
